module.exports = __webpack_public_path__ + "Flag-686.88080fd8f863a52f14082fb6bc5a8376.svg";